/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { FC, PropsWithChildren } from 'react';

interface BtnProps {
    label?: string;
    onClick: () => void;
}

const Btn: FC<PropsWithChildren<BtnProps>> = ({ label, onClick, children }) => {
    return (
        <button className={`vp-btn${label ? ' label' : ''}`} data-label={label} onClick={onClick}>
            {children}
        </button>
    );
};

export default Btn;
